import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
export default class VimeoModal {
  constructor() {
    this.contents = document.querySelector('._vimeo_modal');
    if(!this.contents)return;
    this.container = this.contents.querySelector('._container');

    this.open = document.querySelectorAll('.f-vimeoOpen');
    this.close = document.querySelectorAll('.f-vimeoClose');
    this.vimeoPlayer = document.querySelectorAll('.f-vimeoPlayer');

    this.player = [];
    this.vimeoPlayer.forEach((elm, index) => {
      this.player.push(new Vimeo.Player(elm));
    });

    this.isOpen = false;
    
    this.setup()
  }

  setup () {
    store.subscribe(((mutation, state) => {

      if(store.getters['vimeoModal']())
      {
        if(!this.isOpen)
        {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(function()
          {
            this.contents.focus();
          }.bind(this), 300);
        }
      }
      else
      {
        if(this.isOpen)
        {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );

          for(var i = 0; i <  this.player.length; i++)
          {
            if(this.player[i]) this.player[i].pause();
          }
        }
      }
    }));
    this.close.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setVimeoModal', {
          sta: false
        });
      });
    });
    this.open.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setVimeoModal', {
          sta: true
        });
      });
    });
  }

}